import React, { useRef } from "react";
import { Card, Col, Row, Table, Tooltip, Skeleton, Input } from "antd";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  ArrowLeftOutlined,
  FormOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useClient } from "../../../Context/ClientContext";
import "../../Parties/Party.css";
import { useTheme } from "../../../Context/ThemeContext";
import { ColumnsType } from "antd/es/table";
import LedgerService, {
  LedgerStatus,
  MasterName,
  SearchLedgerByGroupsTypes,
} from "../../../Services/LedgerService";
import { Utils } from "../../../../Utilities/Utils";
import search from "../../../Images/search.svg";
import { AddLedger } from "./AddLedger";
import { useKeyboardShortcuts } from "../../../Common/KeyboardShortcuts ";
import {
  BankAccountTypes,
  getIndianStates,
} from "../../../Services/ClientService";
import { IndianStates } from "../../../../Types/CommonConstants";
import VoucherDetails from "../../Reports/LedgerWiseVoucherDetails/VoucherDetailsByLedger";
import { Party_Tax } from "../../../Services/VoucherServices";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import { premissionLedgerAndGroup } from "../../Users/Roles/UserSecurityFind";
import { dblClick } from "@testing-library/user-event/dist/click";
import { useUser } from "../../../../Context/UserContext";

interface DataType {
  id: any;
  key: React.Key;
  ledgerName: string;
  email: string;
  phone: number;
  balance: number;
}
interface IBankDetail {
  accountType: BankAccountTypes;
  accountNumber?: string;
  bankName?: string;
  ifsCode?: string;
  branch?: string;
  odLimit?: number;
}
const LedgerDetails: React.FC<{
  searchLedgerByGroupsTypes: SearchLedgerByGroupsTypes;
  showName: string;
}> = (props) => {
  console.log("props", props.searchLedgerByGroupsTypes);
  const { ledgerId } = useParams();
  const { themeData } = useTheme();
  const tableRef = useRef();
  const navigate = useNavigate();
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [searchItem, setSearchItem] = React.useState<string>("");
  const [selectedRowKey, setSelectedRowKey] = React.useState<string>(ledgerId!);
  const [tableData, setTableData] = React.useState<any[]>([]);
  const [pageSize, setPageSize] = React.useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [ledgerType, setLedgerType] = React.useState<Party_Tax>(
    Party_Tax.other
  );
  const [totalRecords, setTotalRecords] = React.useState<number>(0);
  const [openModel, setOpenModel] = React.useState<{
    open: boolean;
    id: any;
  }>({
    open: false,
    id: "",
  });
  const [ledgerDetailsData, setLedgerDetailsData] = React.useState<{
    ledgerName: string;
    groupName: string;
    id: string;
    balance: number;
    businessNature?: number;
    gstType?: number;
    gstin?: string;
    state?: IndianStates;
    partyOrTax: number;
    isBankLedger?: boolean;
    bankDetail?: IBankDetail;
    creditLimit?: number;
    taxRate?: number;
    typeOfDuty?: number;
    system: Boolean;
  }>({
    ledgerName: "",
    groupName: "",
    id: "",
    balance: 0,
    businessNature: -1,
    gstType: -1,
    gstin: "",
    state: IndianStates.Unspecified,
    partyOrTax: -1,
    isBankLedger: false,
    creditLimit: -1,
    taxRate: -1,
    typeOfDuty: -1,
    system: false,
  });

  const BusinessNatures = [
    "All",
    "Manufacturer",
    "Service Provider",
    "Hybrid",
    "Trader",
  ];

  const GstType = [
    "Unregistered",
    "Regular",
    "Composition",
    "Consumer",
    "Overseas",
    "SEZ",
    "Deemed Export Import",
  ];

  const DutyType = ["GST", "TDS", "TCS", "Cess", "other"];

  const getLedgerPath = (searchType: SearchLedgerByGroupsTypes, id: string) => {
    switch (searchType) {
      case SearchLedgerByGroupsTypes.PartiesOnly:
        return `/books/clients/${currentClient?.id}/party/partyLedger/${id}`;
      case SearchLedgerByGroupsTypes.AllExpenses:
        return `/books/clients/${currentClient?.id}/expensesLedger/${id}`;
      case SearchLedgerByGroupsTypes.IndirectIncomeOnly:
        return `/books/clients/${currentClient?.id}/incomeLedger/${id}`;
      case SearchLedgerByGroupsTypes.DebtorsOnly:
        return `/books/clients/${currentClient?.id}/sales/customerLedger/${id}`;
      case SearchLedgerByGroupsTypes.CreditorsOnly:
        return `/books/clients/${currentClient?.id}/purchase/supplierLedger/${id}`;
      default:
        return `/books/clients/${currentClient?.id}/master/ledger/${id}`;
    }
  };

  const permissionEdit = premissionLedgerAndGroup(
    currentClient?.id!,
    props.searchLedgerByGroupsTypes,
    IPermissionActionType.Edit,
    MasterName.Ledger,
    clientSpecificRole()
  );

  // --------- Table Columns  ---------
  const columns: ColumnsType<DataType> = [
    {
      title: "",
      key: "id",
      dataIndex: "ledgerName",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <NavLink
            to={getLedgerPath(props.searchLedgerByGroupsTypes, record?.id)}
          >
            <div
              onClick={() => {
                const ledgerDetails = tableData.find(
                  (el: any, i: any) => el?.id === record?.id
                );
                setLedgerType(ledgerDetails.partyOrTax);
                setLedgerDetailsData({
                  ...ledgerDetails,
                  bankDetail:
                    ledgerDetails?.bankDetail && ledgerDetails?.bankDetail[0],
                });
              }}
              style={{
                color: "black",
              }}
            >
              {record?.ledgerName}
            </div>
          </NavLink>
        </Skeleton>
      ),
    },
  ];
  console.log("dataClick", ledgerDetailsData, ledgerId);

  // --------- Table list data ---------
  React.useEffect(() => {
    setLoading(true);
    const getListData = async (searchItem?: string) => {
      await LedgerService.getLedgerList(
        currentClient?.id!,
        0,
        0,
        searchItem,
        "",
        "",
        "",
        "",
        LedgerStatus.all,
        "",
        undefined,
        "",
        "",
        "",
        undefined,
        props.searchLedgerByGroupsTypes
      )
        .then((res: any) => {
          if (res.items) {
            // setTableData(
            //   res?.items?.map((r: any, i: any) => {
            //     let defaultConatct = r?.contactInformation?.find(
            //       (x: any) => x?.isDefault === true
            //     );
            //     // console.log("defaultConatct", defaultConatct);
            //     return {
            //       key: `${r?.id}-${i}`,
            //       sno: i + 1,
            //       id: r?.id,
            //       ledgerName: r?.ledgerName,
            //       parentGroup: r?.groupName,
            //       isBankLedger: r?.isBankLedger,
            //       gstType: r?.gstType,
            //       state: r?.state,
            //       balance: Utils.getFormattedNumber(r?.balance),
            //       // bankDetail: r?.bankDetail && r?.bankDetail[0],
            //       gstin: r?.gstin,
            //       name: defaultConatct?.name,
            //       phone: defaultConatct?.phone,
            //       businessNature: r?.businessNature,
            //     };
            //   })
            // );
            setTotalRecords(res?.totalRecords);
            setTableData(res.items);
            // return console.log("ledgerDetails", ledgerDetails);
            const selLedgerData = res.items.find(
              (el: any, i: any) => el?.id === ledgerId
            );
            setLedgerDetailsData({
              ...selLedgerData,
              bankDetail:
                selLedgerData?.bankDetail && selLedgerData?.bankDetail[0],
            });
            setLedgerType(
              res.items.find((el: any, i: any) => el?.id === ledgerId)
                .partyOrTax
            );

            setLoading(false);
          } else {
            setTableData([]);
            setLoading(false);
            setTotalRecords(res?.totalRecords);
          }
        })
        .catch((err: any) => {
          setLoading(false);
        });
    };
    getListData(searchItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, searchItem]);

  //----- Short-Cut for Item -----
  useKeyboardShortcuts("N", ["shiftKey"], () => {
    setOpenModel({ open: true, id: "" });
  });

  const permissionAdd = premissionLedgerAndGroup(
    currentClient?.id!,
    props.searchLedgerByGroupsTypes,
    IPermissionActionType.Add,
    MasterName.Ledger
  );

  return (
    <>
      <Row>
        <Col span={5} style={{ paddingRight: "5px" }}>
          <Card
            style={{ border: "1.5px solid #eef2fe" }}
            className="ca-card-body"
          >
            <div>
              <Row
                align={"middle"}
                style={{
                  // width: "292px",
                  paddingTop: "5px",
                  borderBottom: "1px solid #DFE9F7",
                }}
              >
                <Col span={3} style={{ padding: "0px 2px" }}>
                  <div style={{ textAlign: "center" }}>
                    <ArrowLeftOutlined onClick={() => navigate(-1)} />
                  </div>
                </Col>
                <Col span={18}>
                  <Input
                    allowClear
                    width={"80%"}
                    style={{ margin: "5px 0px 5px 0px" }}
                    placeholder="Search ledger.."
                    onChange={(e: any) => {
                      setLoading(true);
                      if (!e.cancelable) {
                        const searchItem = setTimeout(() => {
                          setSearchItem(e.target.value);
                        }, 1000);
                        return () => clearTimeout(searchItem);
                      } else {
                        // console.log("Click cancle............");
                        setSearchItem(e.target.value);
                      }
                    }}
                    suffix={
                      loading || searchItem ? (
                        ""
                      ) : (
                        <img alt="Search.." src={search} />
                      )
                    }
                  />
                </Col>
                {permissionAdd && (
                  <Col span={3} style={{ padding: "0px 2px" }}>
                    <div style={{ textAlign: "center" }}>
                      <PlusOutlined
                        onClick={() => {
                          setOpenModel({ open: true, id: "" });
                        }}
                      />
                    </div>
                  </Col>
                )}
                {/* <Col lg={2}>
                  <Popover
                    trigger="click"
                    placement="bottomRight"
                    arrow={{ pointAtCenter: true }}
                    content={
                      <Row style={{ maxWidth: "230px" }}>
                        <Col lg={24}>
                          <Select
                            style={{ width: "100%" }}
                            options={[
                              {
                                label: "All",
                                value: 0,
                              },
                              { label: "Customer", value: 1 },
                              { label: "Suppliers", value: 2 },
                            ]}
                          />
                        </Col>
                        <Col lg={24} style={{ marginTop: "6px" }}>
                          <Select
                            allowClear
                            style={{ width: "100%" }}
                            placeholder="GST Type"
                            // value={party}
                            options={[
                              {
                                label: "Unregistered",
                                value: 0,
                              },
                              { label: "Regular", value: 1 },
                              { label: "Composition", value: 2 },
                            ]}
                          />
                        </Col>
                        <Col lg={24} style={{ marginTop: "6px" }}>
                          <Select
                            allowClear
                            showSearch
                            style={{ width: "100%" }}
                            placeholder="State"
                            optionFilterProp="children"
                          />
                        </Col>
                        <Col lg={24} style={{ marginTop: "6px" }}>
                          <Row justify="space-around">
                            <Button type="primary">Apply</Button>
                            <Button danger>Reset</Button>
                            <Button>Close</Button>
                          </Row>
                        </Col>
                      </Row>
                    }
                  >
                    <FilterFilled
                      style={{ color: "#9AAEC1", fontSize: "16px" }}
                    />
                  </Popover>
                </Col>
                <Col lg={1}>
                  <DownOutlined />
                </Col> */}
              </Row>

              <div
              // style={{
              //   // height: toggle ? "8px " : `calc(100vh - 145px)`,
              //   // backgroundColor: "GrayText",
              //   overflowY: "auto",
              // }}
              >
                <div
                  className={"withoutanimation"}
                  style={{
                    maxHeight: "100%",
                    overflowY: "auto",
                    position: "relative",
                  }}
                >
                  <Table
                    rowClassName={(record) => {
                      return record?.id === ledgerDetailsData?.id
                        ? "ca-active-table"
                        : "";
                    }}
                    className={`Tabel-style-none table-${
                      themeData?.componentSize ?? "middle"
                    }`}
                    showHeader={false}
                    // rowSelection={rowSelection}
                    dataSource={
                      loading
                        ? (Array.from({ length: pageSize }, (_, index) => ({
                            key: `loading-${index}`,
                          })) as DataType[])
                        : tableData
                    }
                    columns={columns}
                    pagination={false}
                  />
                </div>

                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#F5F8FF",
                    height: "40px",
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <th className="textStart">Total</th>
                        <th style={{ textAlign: "end" }}>{totalRecords}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Card>
        </Col>
        <Col
          span={19}
          // style={{ paddingLeft: "22px" }}
          className="ca-card-body-padding"
        >
          {/* // Ledger's Detail */}
          <Card
            style={{
              border: "1.5px solid #eef2fe",
              marginBottom: "10px",
            }}
          >
            <Row>
              {ledgerType === Party_Tax.party ? (
                <Col span={23}>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {/* //Name, Balance, GST Type and State */}
                      <tr style={{ color: "GrayText" }}>
                        <td style={{ width: "25%" }}>Ledger</td>
                        <td style={{ width: "25%" }}>Balance</td>
                        <td style={{ width: "25%" }}>GST Type</td>
                        <td style={{ width: "25%" }}>State</td>
                      </tr>
                      {/* // Values */}
                      <tr>
                        <td>
                          {ledgerDetailsData?.ledgerName?.length > 30 ? (
                            <Tooltip
                              title={ledgerDetailsData?.ledgerName}
                              placement="top"
                              color="#3D4998"
                            >
                              {ledgerDetailsData?.ledgerName.slice(0, 30) +
                                "..."}
                            </Tooltip>
                          ) : (
                            ledgerDetailsData?.ledgerName
                          )}
                        </td>
                        <td>
                          {ledgerDetailsData?.balance === 0
                            ? 0
                            : ledgerDetailsData?.balance > 0
                            ? Utils.getFormattedNumber(
                                ledgerDetailsData?.balance
                              ) + " Dr"
                            : Utils.getFormattedNumber(
                                Math.abs(ledgerDetailsData?.balance)
                              ) + " Cr"}
                        </td>
                        <td>{GstType[ledgerDetailsData?.gstType!]}</td>
                        <td>
                          {ledgerDetailsData?.state === 0
                            ? ""
                            : getIndianStates(ledgerDetailsData?.state!)}
                        </td>
                      </tr>
                      {/* //Group, Business Nature, GSTIN and Credit Limit */}
                      <tr style={{ color: "GrayText" }}>
                        <td style={{ width: "25%" }}>Group</td>
                        <td style={{ width: "25%" }}>Business Nature</td>
                        <td style={{ width: "25%" }}>GSTIN</td>
                        <td style={{ width: "25%" }}>Credit Limit</td>
                      </tr>
                      {/* //Values */}
                      <tr>
                        <td>{ledgerDetailsData?.groupName}</td>
                        <td>
                          {ledgerDetailsData?.businessNature &&
                            BusinessNatures[ledgerDetailsData?.businessNature]}
                        </td>
                        <td>{ledgerDetailsData?.gstin}</td>
                        <td>
                          {Utils.getFormattedNumber(
                            ledgerDetailsData?.creditLimit
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              ) : ledgerType === Party_Tax.BanknCash &&
                ledgerDetailsData?.isBankLedger ? (
                <Col span={23}>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {/* //Name, Balance, GST Type and State */}
                      <tr style={{ color: "GrayText" }}>
                        <td style={{ width: "40%" }}>Ledger</td>
                        <td style={{ width: "40%" }}>Group</td>
                        <td style={{ width: "20%" }}>Balance</td>
                      </tr>
                      {/* // Values */}
                      <tr>
                        <td>
                          {ledgerDetailsData?.ledgerName?.length > 30 ? (
                            <Tooltip
                              title={ledgerDetailsData?.ledgerName}
                              placement="top"
                              color="#3D4998"
                            >
                              {ledgerDetailsData?.ledgerName.slice(0, 30) +
                                "..."}
                            </Tooltip>
                          ) : (
                            ledgerDetailsData?.ledgerName
                          )}
                        </td>
                        <td>{ledgerDetailsData?.groupName}</td>
                        <td>
                          {ledgerDetailsData?.balance === 0
                            ? 0
                            : ledgerDetailsData?.balance > 0
                            ? Utils.getFormattedNumber(
                                ledgerDetailsData?.balance
                              ) + " Dr"
                            : Utils.getFormattedNumber(
                                Math.abs(ledgerDetailsData?.balance)
                              ) + " Cr"}
                        </td>
                      </tr>
                      <tr style={{ color: "GrayText" }}>
                        <td style={{ width: "40%" }}>Account Type</td>
                        <td style={{ width: "40%" }}>A/c No.</td>
                        <td style={{ width: "20%" }}>Bank Name</td>
                      </tr>
                      <tr>
                        <td>
                          {ledgerDetailsData?.bankDetail?.accountType ===
                          BankAccountTypes.SavingAccount
                            ? "Saving Account"
                            : ledgerDetailsData?.bankDetail?.accountType ===
                              BankAccountTypes.CurrentAccount
                            ? "Current Account"
                            : ledgerDetailsData?.bankDetail?.accountType ===
                              BankAccountTypes.CashCreditAccount
                            ? "Cash Credit Account"
                            : ledgerDetailsData?.bankDetail?.accountType ===
                              BankAccountTypes.OverdraftAccount
                            ? "Overdraft Account"
                            : "Credit Card"}
                        </td>
                        <td>{ledgerDetailsData?.bankDetail?.accountNumber}</td>
                        <td>{ledgerDetailsData?.bankDetail?.bankName}</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              ) : (
                <Col span={23}>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {/* //Name, Group and Balance */}
                      <tr style={{ color: "GrayText" }}>
                        <td style={{ width: "40%" }}>Ledger</td>
                        <td style={{ width: "40%" }}>Group</td>
                        <td style={{ width: "20%" }}>Balance</td>
                      </tr>
                      {/* // Values */}
                      <tr>
                        <td>
                          {ledgerDetailsData?.ledgerName?.length > 30 ? (
                            <Tooltip
                              title={ledgerDetailsData?.ledgerName}
                              placement="top"
                              color="#3D4998"
                            >
                              {ledgerDetailsData?.ledgerName.slice(0, 30) +
                                "..."}
                            </Tooltip>
                          ) : (
                            ledgerDetailsData?.ledgerName
                          )}
                        </td>
                        <td>{ledgerDetailsData?.groupName}</td>
                        <td>
                          {ledgerDetailsData?.balance === 0
                            ? 0
                            : ledgerDetailsData?.balance > 0
                            ? Utils.getFormattedNumber(
                                ledgerDetailsData?.balance
                              ) + " Dr"
                            : Utils.getFormattedNumber(
                                Math.abs(ledgerDetailsData?.balance)
                              ) + " Cr"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              )}
              {permissionEdit && (
                <Col span={1} style={{ textAlign: "right", padding: "0 8px" }}>
                  <Tooltip
                    title={
                      ledgerDetailsData?.system
                        ? "Default ledger are not editable"
                        : "Edit"
                    }
                    placement="top"
                    color={
                      ledgerDetailsData?.system ? "rgb(216 207 207)" : "#444653"
                    }
                  >
                    <FormOutlined
                      className="ca-edit-btn"
                      // style={{ color: "#a5abdd" }}
                      style={{
                        color: ledgerDetailsData?.system
                          ? "rgb(216 207 207)"
                          : "#444653",
                      }}
                      onClick={() => {
                        !ledgerDetailsData?.system &&
                          setOpenModel({
                            open: true,
                            id: ledgerDetailsData?.id,
                          });
                      }}
                    />
                  </Tooltip>
                </Col>
              )}
            </Row>

            {/* <Row>
              <Col span={6}>
                <div>
                  <span
                    style={{
                      paddingRight: "10px",
                      color: "rgb(139, 143, 165)",
                    }}
                  >
                    Ledger:
                  </span>
                  {ledgerDetailsData?.ledgerName?.length > 30 ? (
                    <Tooltip
                      title={ledgerDetailsData?.ledgerName}
                      placement="top"
                      color="#3D4998"
                    >
                      {ledgerDetailsData?.ledgerName.slice(0, 30) + "..."}
                    </Tooltip>
                  ) : (
                    ledgerDetailsData?.ledgerName
                  )}
                </div>
                <div>
                  <span
                    style={{
                      paddingRight: "10px",
                      color: "rgb(139, 143, 165)",
                    }}
                  >
                    Group:
                  </span>
                  {ledgerDetailsData?.groupName}
                </div>
              </Col>
              <Col span={6}>
                <div>
                  <span
                    style={{
                      paddingRight: "14px",
                      color: "rgb(139, 143, 165)",
                    }}
                  >
                    Balance:
                  </span>
                  {ledgerDetailsData?.balance === 0
                    ? 0
                    : ledgerDetailsData?.balance > 0
                    ? Utils.getFormattedNumber(ledgerDetailsData?.balance) +
                      " Dr"
                    : Utils.getFormattedNumber(
                        Math.abs(ledgerDetailsData?.balance)
                      ) + " Cr"}
                </div>
                {ledgerDetailsData?.partyOrTax === 1 && (
                  <>
                    <div>
                      <span
                        style={{
                          paddingRight: "10px",
                          color: "rgb(139, 143, 165)",
                        }}
                      >
                        Business Nature:
                      </span>
                      {BusinessNatures[ledgerDetailsData?.businessNature]}
                    </div>
                  </>
                )}
                {ledgerDetailsData?.partyOrTax === 2 && (
                  <>
                    <div>
                      <span
                        style={{
                          paddingRight: "10px",
                          color: "rgb(139, 143, 165)",
                        }}
                      >
                        Type of Duty:
                      </span>
                      {DutyType[ledgerDetailsData?.typeOfDuty]}
                    </div>
                  </>
                )}
              </Col>
              <Col span={5}>
                {ledgerDetailsData?.partyOrTax === 1 && (
                  <>
                    <div>
                      <span
                        style={{
                          paddingRight: "16px",
                          color: "rgb(139, 143, 165)",
                        }}
                      >
                        GST Type:
                      </span>
                      {GstType[ledgerDetailsData?.gstType]}
                    </div>
                  </>
                )}
                {ledgerDetailsData?.partyOrTax === 2 && (
                  <>
                    <div>
                      <span
                        style={{
                          paddingRight: "16px",
                          color: "rgb(139, 143, 165)",
                        }}
                      >
                        Tax Rate:
                      </span>
                      {ledgerDetailsData?.taxRate
                        ? ledgerDetailsData?.taxRate + "%"
                        : ""}
                    </div>
                  </>
                )}
                {ledgerDetailsData?.partyOrTax === 1 && (
                  <>
                    <div>
                      <span
                        style={{
                          paddingRight: "10px",
                          color: "rgb(139, 143, 165)",
                        }}
                      >
                        GSTIN:
                      </span>
                      {ledgerDetailsData?.gstin}
                    </div>
                  </>
                )}
              </Col>
              <Col span={6}>
                {ledgerDetailsData?.partyOrTax === 1 && (
                  <>
                    <div>
                      <span
                        style={{
                          paddingRight: "10px",
                          color: "rgb(139, 143, 165)",
                        }}
                      >
                        State:
                      </span>
                      {getIndianStates(ledgerDetailsData?.state)}
                    </div>
                  </>
                )}
                {ledgerDetailsData?.partyOrTax === 1 && (
                  <>
                    <div>
                      <span
                        style={{
                          paddingRight: "10px",
                          color: "rgb(139, 143, 165)",
                        }}
                      >
                        Credit Limit:
                      </span>
                      {ledgerDetailsData?.creditLimit}
                    </div>
                  </>
                )}
              </Col>
              <Col span={1} style={{ textAlign: "center" }}></Col>
            </Row> */}
          </Card>
          {/* // Voucher Details */}
          <Card className="ca-card-body">
            <div
              style={{
                height: `calc(100vh - 168px)`,
                // backgroundColor: "azure",
                overflowY: "auto",
              }}
            >
              <VoucherDetails
                ledgerId={ledgerDetailsData?.id}
                ledgerName={ledgerDetailsData?.ledgerName}
              />
            </div>
          </Card>
        </Col>
      </Row>
      {openModel.open && (
        <AddLedger
          openDrawer={openModel.open}
          id={openModel?.id}
          setOpenDrawer={() => setOpenModel({ open: false, id: "" })}
          setTrigger={() => setTrigger(!trigger)}
          type={props?.searchLedgerByGroupsTypes}
          showName={props?.showName}
        />
      )}
    </>
  );
};

export default LedgerDetails;
